export default __webpack_public_path__ + "static/WWineBoxBG-a4321a32a0bd9f7ebd2c1ae6878dc3fb.jpg";